<div class="w-full">
    <div class="flex items-start justify-between gap-3">
    <div #title class="font-bold uppercase text-surface-900" style="font-size: 18px;">
      {{ widgetHeader() }}
    </div>

    <div #action class="flex items-center gap-2">
      <p-select
        [options]="rangeOptions"
        optionLabel="label"
        optionValue="value"
        [formControl]="rangeControl"
        class="earnings-range-select"
      ></p-select>
       <p-select
        [options]="rangeTypes"
        optionLabel="label"
        optionValue="value"
        [formControl]="rangeTypeControl"
        class="earnings-range-select"
      ></p-select>
    </div>
  </div>

  <div class="mt-5 shrink-0">
     <app-table-loading-overlay></app-table-loading-overlay>
    <p-chart #chartRef *ngIf="data() && options()" type="bar" [data]="data()" [options]="options()"
      [plugins]="plugins()"></p-chart>
    <div class="flex flex-wrap gap-2 mt-2 justify-end">
      <div class="flex flex-wrap gap-2  mt-0">
        <button type="button" *ngFor="let chip of legendChips" class="legend-tag-btn" [class.is-hidden]="chip.hidden"
          (click)="toggleDataset(chip)">
          <p-tag class="legend-tag" [value]="chip.label" [style.--legend-color]="chip.color"
            [style.--legend-bg]="withAlpha(chip.color, 0.14)" [style.--legend-border]="withAlpha(chip.color, 0.22)">
          </p-tag>
        </button>
      </div>
    </div>

    
  </div>

</div>
